import { Box, makeStyles, Typography } from "@material-ui/core";
import React from "react";

import { CustomButton } from "@/components/Button";
import { layoutTokens, semanticColors as colors, textStyles } from "@/designTokens";
import theme from "@/theme";

export const MESSAGE_UNAVAILABLE_TITLE = "このメッセージは表示できません";
const MESSAGE_UNAVAILABLE_DESCRIPTION = "送信元のプランナーが退会したか、\n掲載が終了した可能性があります";

const useStyles = makeStyles({
  root: {
    padding: "32px 24px",
    background: colors["surface/base"],
    minHeight: "calc(100vh - 56px)",
    [theme.breakpoints.up("md")]: { padding: 0, minHeight: 0 },
  },
  panel: {
    padding: "32px 16px",
    textAlign: "center",
    borderRadius: layoutTokens.radius.lg,
    background: colors["surface/card"],
    [theme.breakpoints.up("md")]: { padding: "64px 48px" },
  },
  title: {
    ...textStyles["SP/Heading/H3"],
    color: colors["text/primary"],
    [theme.breakpoints.up("md")]: { color: colors["text/heading"] },
  },
  description: {
    ...textStyles["SP/Body/Large"],
    color: colors["text/secondary"],
    whiteSpace: "pre-line",
    margin: "16px 0 24px",
    [theme.breakpoints.up("md")]: { ...textStyles["PC/Body/Large"], margin: "8px 0 0" },
  },
  button: { display: "inline-flex", maxWidth: "100%", margin: "0 auto" },
});

export const MessageUnavailable: React.FC<{ onBackToList?: () => void }> = ({ onBackToList }) => {
  const classes = useStyles();
  return (
    <Box className={classes.root} data-testid="proposal-not-found">
      <Box className={classes.panel}>
        <Typography component="h2" className={classes.title}>
          {MESSAGE_UNAVAILABLE_TITLE}
        </Typography>
        <Typography className={classes.description}>{MESSAGE_UNAVAILABLE_DESCRIPTION}</Typography>
        {onBackToList && (
          <Box className={classes.button}>
            <CustomButton tone="outline" buttonSize="M" onClick={onBackToList}>
              メッセージ一覧へ戻る
            </CustomButton>
          </Box>
        )}
      </Box>
    </Box>
  );
};
